import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Modal, TextInput, Select, FileInput, Textarea, Title, Group, Badge } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { toast } from 'react-toastify';

const DROPS_API = 'https://backend.cdp3d.com/api/drops';

const DropsManager = () => {
    const [drops, setDrops] = useState([]);
    const [opened, { open, close }] = useDisclosure(false);
    const [form, setForm] = useState({
        name: '', description: '', status: 'upcoming', releaseDate: '', bannerImage: ''
    });
    const [file, setFile] = useState(null);

    const fetchDrops = async () => {
        try {
            const res = await fetch(DROPS_API);
            const data = await res.json();
            setDrops(data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchDrops(); }, []);

    const handleUpload = async () => {
        if (!file) return form.bannerImage;
        const formData = new FormData();
        formData.append('modelFile', file); // reusing the generic upload endpoint
        const res = await fetch('https://backend.cdp3d.com/api/upload-model', {
            method: 'POST', body: formData
        });
        const data = await res.json();
        return data.filePath;
    };

    const handleSubmit = async () => {
        try {
            const bannerPath = await handleUpload();
            const payload = { ...form, bannerImage: bannerPath };
            
            await fetch(DROPS_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            toast.success('Drop created!');
            close();
            fetchDrops();
        } catch (err) {
            toast.error('Failed to create drop');
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <Group position="apart" mb="md">
                <Title order={2}>Drops Manager</Title>
                <Button onClick={open}>Create Drop</Button>
            </Group>

            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Release Date</th>
                        <th>Products</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {drops.map(drop => (
                        <tr key={drop._id}>
                            <td>{drop.name}</td>
                            <td><Badge color={drop.status === 'active' ? 'green' : 'blue'}>{drop.status}</Badge></td>
                            <td>{new Date(drop.releaseDate).toLocaleDateString()}</td>
                            <td>{drop.products?.length || 0}</td>
                            <td>
                                <Button component={Link} to={`/drops/${drop._id}`} variant="light" size="xs">Manage</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal opened={opened} onClose={close} title="Create New Drop">
                <TextInput label="Name" mb="sm" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                <Textarea label="Description" mb="sm" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
                <Select label="Status" mb="sm" data={['upcoming', 'active', 'ended']} value={form.status} onChange={(val) => setForm({ ...form, status: val })} />
                <TextInput type="date" label="Release Date" mb="sm" value={form.releaseDate} onChange={(e) => setForm({ ...form, releaseDate: e.target.value })} />
                <FileInput label="Banner Image" mb="lg" value={file} onChange={setFile} />
                <Button fullWidth onClick={handleSubmit}>Save Drop</Button>
            </Modal>
        </div>
    );
};

export default DropsManager;
